import { useEffect, useState } from "react";
import Button from "../atoms/button";
import { searchUsers } from "./functions";

const PromoteModal = ({ open, user, onClose, onPromote }) => {
    const [query, setQuery] = useState("");
    const [results, setResults] = useState([]);
    const [selected, setSelected] = useState(null);
    const [makeMaster, setMakeMaster] = useState(false);
    const [message, setMessage] = useState("");
    const [busy, setBusy] = useState(false);

    // Limpa o estado sempre que o modal fecha — seja por sucesso (parent faz
    // setPromoteOpen(false)) ou por "Cancelar". Como o componente usa
    // `if (!open) return null`, os hooks persistem entre aberturas; sem isso
    // reabrir o modal mostrava busca/seleção obsoletas.
    useEffect(() => {
        if (!open) {
            setQuery("");
            setResults([]);
            setSelected(null);
            setMakeMaster(false);
            setMessage("");
        }
    }, [open]);

    if (!open) return null;

    const handleSearch = async () => {
        setBusy(true);
        setSelected(null);
        const data = await searchUsers(user.token, query);
        setBusy(false);
        if (data.type === "error") {
            setMessage(data.message);
            setResults([]);
            return;
        }
        setMessage(data.data.length ? "" : "Nenhum usuário encontrado");
        setResults(data.data);
    };

    const handleConfirm = async () => {
        if (!selected) return;
        setBusy(true);
        await onPromote(selected, { admin: true, master: makeMaster });
        setBusy(false);
    };

    // O useEffect acima já limpa o estado quando `open` vira false; aqui só
    // dispara o fechamento (cobre também o fechamento por sucesso).
    const reset = () => {
        onClose();
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
            <div className="w-[520px] rounded-lg border border-[#d59106] bg-[#1c1917] p-6">
                <h3 className="mb-4 text-lg">Adicionar admin</h3>
                <div className="mb-4 flex gap-2">
                    <input
                        type="text"
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                        placeholder="Nome ou e-mail"
                        className="flex-1 rounded px-2 py-1 text-black"
                    />
                    <Button classes="bg-[#d59106] hover:bg-orange-500" click={handleSearch} disabled={busy}>Buscar</Button>
                </div>
                {message ? <p className="mb-2 text-sm">{message}</p> : null}
                <ul className="mb-4 max-h-56 overflow-y-auto">
                    {results.map((result) => (
                        <li key={result._id}>
                            <button
                                type="button"
                                onClick={() => setSelected(result)}
                                className={`w-full px-2 py-1 text-left hover:bg-[#333] ${selected?._id === result._id ? "bg-[#333]" : ""}`}
                            >
                                {result.name} — {result.email}
                                {result.roles.includes("admin") || result.roles.includes("master") ? " (já é staff)" : ""}
                            </button>
                        </li>
                    ))}
                </ul>
                <label className="mb-4 flex items-center gap-2">
                    <input type="checkbox" checked={makeMaster} onChange={() => setMakeMaster(!makeMaster)} />
                    Conceder também acesso master
                </label>
                <div className="flex justify-end gap-3">
                    <Button classes="bg-gray-600 hover:bg-gray-700" click={reset}>Cancelar</Button>
                    <Button classes="bg-green-500 hover:bg-green-600" click={handleConfirm} disabled={!selected || busy}>
                        Promover
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default PromoteModal;
